// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"add07653","404":"47e54d4e","498":"4d07eba2"}[chunkId] + ".chunk.js";
};